export default (feature) => {
    var _a;
    return feature && ((_a = feature.get("data")) === null || _a === void 0 ? void 0 : _a.id)
        ? feature.get("data")
        : undefined;
};
